import { NSASectionViewTabPage, NSASectionViewTabPageUIProps } from "./NSASectionViewTabPage";
import { IEntityInfo } from "../IEntityInfo";
import { Component, createRef, ReactNode } from "react";
import { IBaseComponentProps, NSLoading } from "namirasoft-site-react";
import { NSARouterMakerProps } from "../NSARouterMakerProps";
import { CategoryRow, FieldRow } from "namirasoft-field";

export interface NSASectionViewCutomProps<RowType> extends IBaseComponentProps
{
	ui?: {
		view_tab_page?: NSASectionViewTabPageUIProps;
		getChildrenBefore?: (id: string, row: RowType) => ReactNode;
		getChildrenAfter?: (id: string, row: RowType) => ReactNode;
	};
	onRowLoaded?: (row: RowType) => void;
}

export interface NSASectionViewProps<RowType extends { id: string }, RowTypeInput = RowType> extends NSARouterMakerProps, NSASectionViewCutomProps<RowType>
{
	entity: IEntityInfo<RowType, RowTypeInput>;
	ctf: {
		enabled: boolean;
		fields: FieldRow[] | null;
		categories: CategoryRow[] | null;
	};
	model: {
		id: string | null;
		row: RowType | null;
	};
	deleteFieldCache: () => void;
}

interface NSASectionViewState<RowType>
{
	row: RowType | null;
}

export class NSASectionView<RowType extends { id: string }, RowTypeInput = RowType> extends Component<NSASectionViewProps<RowType, RowTypeInput>, NSASectionViewState<RowType>>
{
	NSASectionViewTabPage_Ref = createRef<NSASectionViewTabPage<RowType, RowTypeInput>>();

	constructor(props: NSASectionViewProps<RowType, RowTypeInput>)
	{
		super(props);

		this.state = { row: this.props.model.row };

		this.reload = this.reload.bind(this);
		this.getRow = this.getRow.bind(this);
	}
	reload() 
	{
		this.setState(prev => ({ ...prev, row: null }));
		if (this.props.model.id)
			if (this.props.entity.server.get)
				this.props.entity.server.get(this.props.model.id).then(row =>
				{
					this.setState(prev => ({ ...prev, row }), () =>
					{
						this.props.onRowLoaded?.(row);
					});
				}).catch(() => { });
	}
	getRow()
	{
		return this.state.row;
	}
	override componentDidMount()
	{
		if (this.props.model.id)
			if (!this.props.model.row || this.props.model.row.id !== this.props.model.id)
				this.reload();
	}
	override render()
	{
		if (this.props.model.id && this.state.row != null)
			return (
				<div
					id={this.props.id}
					className={`${this.props.classList?.join(" ") ?? ""}`}
					style={{ ...this.props.style }}
				>
					{this.props.ui?.getChildrenBefore && this.props.ui?.getChildrenBefore(this.props.model.id, this.state.row)}
					<NSASectionViewTabPage<RowType, RowTypeInput>
						ref={this.NSASectionViewTabPage_Ref}
						{...this.props}
						ui={this.props.ui?.view_tab_page}
					/>
					{this.props.ui?.getChildrenAfter && this.props.ui?.getChildrenAfter(this.props.model.id, this.state.row)}
				</div>
			);

		return <NSLoading></NSLoading>;
	}
}